export const SHARE_TYPE = {
	fb: 'Facebook',
	wa: 'WhatsApp',
	tw: 'Twitter',
	email: 'E-mail',
} as const;
